import AirtimeOne from '../../pages/PayBills/AirtimeData';
import React, { useState } from 'react';
import { observer } from 'mobx-react';

const AirtimeContainer = ({ closeModal, setShowSurvey }) => {
	const [buyAirtimeContent, setBuyAirtimeContent] = useState(false);

	const [buyDataContent, setBuyDataContent] = useState(false);
	const [mainContent, setMainContent] = useState(true);
	const [pinContent, setPinContent] = useState(false);

	const buydata = () => {
		setBuyDataContent(true);
		setMainContent(false);
		setPinContent(false);
	};

	const buyAirtime = () => {
		setBuyAirtimeContent(true);
		setMainContent(false);
		setPinContent(false);
	};

	const goBack = () => {
		if (buyAirtimeContent) {
			setBuyAirtimeContent(false);
			setMainContent(true);
		} else if (buyDataContent) {
			setBuyDataContent(false);
			setMainContent(true);
		} else if (pinContent) {
			setPinContent(false);
		} else {
			closeModal();
		}
	};

	return (
		<AirtimeOne
			buyAirtimeContent={buyAirtimeContent}
			buyDataContent={buyDataContent}
			buydata={buydata}
			buyAirtime={buyAirtime}
			closeModal={closeModal}
			mainContent={mainContent}
			goBack={goBack}
			pinContent={pinContent}
			setPinContent={setPinContent}
			setShowSurvey={setShowSurvey}
		/>
	);
};

export default observer(AirtimeContainer);
